<template>
    <div class="no-content">
        <!-- <img src="@/assets/images/no_data.png" /> -->
    </div>
</template>

<script>
// 无内容时显示的组件
export default {
    name: 'noContent'
};
</script>

<style scoped lang="scss">
.no-content {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
